import { match } from 'ts-pattern'
import { blocknoteSchema } from '../blocknoteSchema'

type BlocknoteBlock = (typeof blocknoteSchema.BlockNoteEditor)['document'][0]

/**
 * We disable justify aligned text by removing the control from the formatting toolbar, but users can still paste
 * in justify aligned text from another app, causing the rendered text to look shonky.
 */
export const realignJustifiedText = (
  blockNoteEditor: typeof blocknoteSchema.BlockNoteEditor
) => {
  const blocks = blockNoteEditor.document

  for (const block of blocks) {
    realignBlock(block, blockNoteEditor)
  }
}

const realignBlock = (
  block: BlocknoteBlock,
  blockNoteEditor: typeof blocknoteSchema.BlockNoteEditor
) => {
  match(block)
    .with(
      { type: 'paragraph' },
      { type: 'heading' },
      { type: 'bulletListItem' },
      { type: 'numberedListItem' },
      alignedBlock => {
        for (const child of alignedBlock.children) {
          realignBlock(child, blockNoteEditor)
        }

        if (alignedBlock.props.textAlignment !== 'justify') return

        blockNoteEditor.updateBlock(alignedBlock, {
          props: { textAlignment: 'left' }
        })
      }
    )
    .with({ type: 'table' }, () => {
      /**
       * Text alignment isn't persisted with text pasted into table cells,
       * so do nothing for tables
       */
    })
    .with({ type: 'divider' }, { type: 'image' }, { type: 'phases' }, () => {
      /**
       * Text alignment not relevant to these block types. Images can have text alignment,
       * but rendering isn't negatively impacted when justify aligned.
       */
    })
    .exhaustive()
}
